import React, { useState, useEffect } from "react";
import { Button, Dropdown, Modal, Table } from "react-bootstrap";
import ItemsForm from "./ItemsForm";
import axios from "axios";

const BASE_URL = 'https://whapi.infosware-test.in'; // Define base URL

function Items() {
  const [view, setView] = useState("list");
  const [selectedItem, setSelectedItem] = useState(null);
  const [items, setItems] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = () => {
    axios
      .get(`${BASE_URL}/items`)
      .then((response) => setItems(response.data))
      .catch((error) => console.error("Error fetching items:", error));
  };

  const handleDeleteItem = () => {
    axios
      .delete(`${BASE_URL}/items/${selectedItem.id}`)
      .then(() => {
        setItems(items.filter((item) => item.id !== selectedItem.id));
        setShowDeleteModal(false);
        setSelectedItem(null); // Clear the selected item after deletion
      })
      .catch((error) => console.error("Error deleting item:", error));
  };

  const renderContent = () => {
    if (view === "list") {
      return (
        <div className="p-4">
          <div className="d-flex justify-content-between align-items-center mt-4 mb-4">
            <h3>Items List</h3>
            <Button variant="primary" onClick={() => setView("add")}>
              New Item
            </Button>
          </div>
          <Table striped bordered hover responsive className="mb-5 mt-2">
            <thead>
              <tr>
                <th>Sr.no</th>
                <th>Product Name</th>
                <th>Packing</th>
                <th>Quantity</th>
                <th>SKU</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.name}</td>
                  <td>{item.packing}</td>
                  <td>{item.quantity}</td>
                  <td>{item.sku}</td>
                  <td>
                    <div className="d-flex justify-content-end align-reports-center gap-4 p-1">
                      <Dropdown>
                        <Dropdown.Toggle variant="primary">Actions</Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item className="text-success" onClick={() => { setSelectedItem(item); setView("edit"); }}>Edit</Dropdown.Item>
                          <Dropdown.Item className="text-danger" onClick={() => { setSelectedItem(item); setShowDeleteModal(true); }}>Delete</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      );
    }

    if (view === "add" || view === "edit") {
      return (
        <ItemsForm item={view === "edit" ? selectedItem : null} onCancel={() => setView("list")} onSave={onSave}
        />
      );
    }

    return null;
  };

  const onSave = (newItemData) => {
    if (view === "edit") {
      setItems(items.map(item => item.id === selectedItem.id ? newItemData : item));
      setSelectedItem(null); // Clear the selected item after editing
    } else {
      setItems([...items, newItemData]);
    }
    setView("list"); // Close the form and render items list
    fetchItems(); // Fetch the updated list of items
  };

  return (
    <div>
      {renderContent()}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this item?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancel</Button>
          <Button variant="danger" onClick={handleDeleteItem}>Delete</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Items;
